"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _range = _interopRequireDefault(require("lodash/range"));

var _gauge = _interopRequireDefault(require("@amzn/meridian-tokens/component/gauge"));

var _theme = require("../theme");

var _angle = require("./../_utils/angle");

var _token = require("./../_utils/token");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getTextAlignment = function getTextAlignment(angle) {
  var a = (0, _angle.normalizeAngle)(angle);
  var textAnchor = a === 90 || a === 270 ? "middle" : a > 90 && a < 270 ? "end" : "start";
  var dominantBaseline = // vertically center text between both the 08:00~10:00 and 02:00~04:00 clock positions
  a < 20 || a > 340 || a > 160 && a < 200 ? "center" : a < 180 ? "hanging" : "baseline";
  return {
    textAnchor: textAnchor,
    dominantBaseline: dominantBaseline
  };
};

var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var textAnchor = _ref.textAnchor;
  return (0, _emotion.css)({
    fontFamily: t("tickMark", "labelFontFamily"),
    fill: t("tickMark", "labelColor"),
    fontWeight: t("tickMark", "labelWeight"),
    textAnchor: textAnchor
  });
}, ["textAnchor"]); // TODO: Allow font-size adjustments, division and subdivision tick mark length adjustments?

var Scale = function Scale(props) {
  var radius = props.radius,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      minValue = props.minValue,
      maxValue = props.maxValue,
      trackWidth = props.trackWidth;
  var t = (0, _theme.useTheme)(_gauge["default"], "gauge");
  var tickMarkLength = t("tickMark", "length");
  var tickMarkSpacing = t("tickMark", "spacing");
  var labelSpacing = t("tickMark", "labelSpacing");
  var sweepAngle = (0, _react.useMemo)(function () {
    return (0, _angle.getSweepAngle)(startAngle, endAngle);
  }, [startAngle, endAngle]);
  var labelAngles = [].concat((0, _toConsumableArray2["default"])((0, _range["default"])(startAngle, startAngle + sweepAngle, sweepAngle / props.divisions)), [endAngle]).map(_angle.normalizeAngle);
  var tickAngles = (0, _react.useMemo)(function () {
    return [].concat((0, _toConsumableArray2["default"])((0, _range["default"])(startAngle, startAngle + sweepAngle, sweepAngle / (props.divisions * props.subdivisions))), [endAngle]).map(_angle.normalizeAngle);
  }, [startAngle, endAngle, sweepAngle, props.divisions, props.subdivisions]); // Draw a tick mark line. Use rotations from `tickAngles` to place.

  var tickMarkPath = (0, _react.useMemo)(function () {
    return "M ".concat(radius - trackWidth - tickMarkSpacing, " 0 h ").concat(-tickMarkLength);
  }, [radius, trackWidth, tickMarkLength, tickMarkSpacing]);
  var labelRadius = radius - trackWidth - labelSpacing;
  return /*#__PURE__*/_react["default"].createElement("g", null, props.divisions > 1 ? tickAngles.map(function (angle) {
    return /*#__PURE__*/_react["default"].createElement("path", {
      key: angle,
      d: tickMarkPath,
      fill: "none",
      transform: "rotate(".concat(angle - 180, ", 0,0)"),
      strokeLinecap: "round",
      stroke: t("tickMark", "color"),
      strokeWidth: t("tickMark", "strokeWidth")
    });
  }) : null, labelAngles.map(function (angle, index) {
    var value = minValue + index / props.divisions * (maxValue - minValue);
    var percent = index / props.divisions;

    var _getTextAlignment = getTextAlignment(angle),
        textAnchor = _getTextAlignment.textAnchor,
        dominantBaseline = _getTextAlignment.dominantBaseline;

    return /*#__PURE__*/_react["default"].createElement("text", {
      key: index,
      x: labelRadius * (0, _angle.cos)(angle - 180),
      y: labelRadius * (0, _angle.sin)(angle - 180),
      className: labelStyles(t, {
        textAnchor: textAnchor
      }) // HACK: Edge and IE11 don't support dominant-baseline so we must
      // vertically nudge the text. We accomplish this by directly adding
      // font-size and then nudge with em (font-size relative) units via dy.
      ,
      fontSize: t("tickMark", "labelFontSize"),
      dy: {
        hanging: "0.7em",
        center: "0.1em",
        baseline: 0
      }[dominantBaseline]
    }, props.renderLabel({
      index: index,
      percent: percent,
      value: value
    }));
  }));
};

Scale.propTypes = process.env.NODE_ENV !== "production" ? {
  divisions: _propTypes["default"].number,
  endAngle: _propTypes["default"].number,
  maxValue: _propTypes["default"].number,
  minValue: _propTypes["default"].number,
  radius: _propTypes["default"].number,
  renderLabel: _propTypes["default"].func,
  startAngle: _propTypes["default"].number,
  subdivisions: _propTypes["default"].number,
  trackWidth: _propTypes["default"].number
} : {};
Scale.defaultProps = {
  divisions: 4,
  subdivisions: 1,
  renderLabel: function renderLabel(_ref2) {
    var value = _ref2.value;
    return value.toLocaleString();
  }
};
var _default = Scale;
exports["default"] = _default;